import { render, staticRenderFns } from "./herderList.vue?vue&type=template&id=b8e4b690&scoped=true"
import script from "./herderList.vue?vue&type=script&lang=js"
export * from "./herderList.vue?vue&type=script&lang=js"
import style0 from "./herderList.vue?vue&type=style&index=0&id=b8e4b690&prod&lang=scss&scoped=true"
import style1 from "./herderList.vue?vue&type=style&index=1&id=b8e4b690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e4b690",
  null
  
)

export default component.exports